import React from 'react'
import { Box, Paper, Button, Typography } from '@material-ui/core'
import parkingButtonPanelStyles from './mapOverlayWarningStyles'

function MapOverlayWarning({ map }) {
  const classes = parkingButtonPanelStyles()

  const [vectorActive, setVectorActive] = React.useState(true)
  const [open, setOpen] = React.useState(true)

  React.useEffect(() => {
    if (!map) return

    const updateRenderingType = () => {
      setVectorActive(map.getRenderingType() === 'VECTOR')
    }

    map.addListener('renderingtype_changed', updateRenderingType)
    updateRenderingType()
    // eslint-disable-next-line
    return () => google.maps.event.clearListeners(map, 'renderingtype_changed')
  }, [map])
  if (vectorActive) return null
  return (
    <>
      {open ? (
        <Box component={Paper} className={classes.mapWarningOverlay}>
          <Typography variant="subtitle1">
            Parking overlays may be degraded or not displayed because hardware
            acceleration is not active. Check your browser settings to enable
            it.
          </Typography>
          <Button
            className={classes.mapWarningOverlayButton}
            onClick={() => setOpen(!open)}
          >
            Dismiss
          </Button>
        </Box>
      ) : null}
    </>
  )
}

export default MapOverlayWarning
